import React, { Fragment, useState } from 'react';
import { Button, Card, Col, Dropdown, Icon, Menu, message, Modal, Row, Tabs, Tag } from 'antd';
import { useHistory } from 'react-router-dom';
import { currencyVND, dateToString } from '../../../../utils';
import * as CommonService from '../../../../services/CommonService';
import { SUPPLIER } from '../../../../services/endpoint';
import OrderHistory from './OrderHistory';
import DebtHistory from './DebtHistory';
import CreateTicket from './CreateTicket';

const { TabPane } = Tabs;

export default (props) => {

	const history = useHistory();

	const [currentTab, setCurrentTab] = useState('1');
	const [showModalCreateTicket, setShowModalCreateTicket] = useState(false);
	const [isIncome, setIsIncome] = useState(false);
	const [reloadDebtList, setReloadDebtList] = useState(0);

	const { supplier } = props;

	const handleDelete = (id) => {
		window.setLoading(true);
		CommonService.deleteRecord(SUPPLIER, null,
			{
				params: { id }
			}).then(() => {
			history.push('/supplier');
			message.success('Xóa nhà cung cấp thành công');
		}).catch(err => {
			message.error(err?.data?.message);
		}).finally(() => {
			window.setLoading(false);
		});
	};

	const [isModalOpen, setIsModalOpen] = useState(false);

	const showModal = () => {
		setIsModalOpen(true);
	};
	const handleOk = () => {
		setIsModalOpen(false);
		handleDelete(supplier.id);
	};
	const handleCancel = () => {
		setIsModalOpen(false);
	};

	const redirectToUpdate = () => {
		history.push(`/supplier/edit/${supplier.id}`);
	};

	const InfoRow = ({ label, value }) => (<Row style={{ marginBottom: 8 }}>
		<Col span={10}>{label}</Col>
		<Col span={14}>: {value || '---'}</Col>
	</Row>);

	const menu = (<Menu>
		<Menu.Item>
			<a target="_blank" rel="noopener noreferrer" onClick={() => {
				setIsIncome(true);
				setShowModalCreateTicket(true);
			}}>
				Tạo phiếu thu
			</a>
		</Menu.Item>
		<Menu.Item>
			<a target="_blank" rel="noopener noreferrer" onClick={() => {
				setIsIncome(false);
				setShowModalCreateTicket(true);
			}}>
				Tạo phiếu chi
			</a>
		</Menu.Item>
		<Menu.Item>
			<a target="_blank" rel="noopener noreferrer" onClick={redirectToUpdate}>
				Cập nhật thông tin
			</a>
		</Menu.Item>
		<Menu.Item>
			<a target="_blank" rel="noopener noreferrer" onClick={showModal}>
				Xoá nhà cung cấp
			</a>
		</Menu.Item>
	</Menu>);

	return (
		<Fragment>
			<Modal
				title="Xóa nhà cung cấp"
				visible={isModalOpen}
				onOk={handleOk}
				onCancel={handleCancel}
			>
				<p>Bạn có chắc chắn muốn xóa nhà cung cấp <b>{supplier.name}</b>? Thao tác này không thể khôi phục.</p>
			</Modal>
			<Card
				title={
					<div>
						<span>Thông tin cá nhân: <b style={{ color: 'blue' }}>{supplier.name}</b></span>
						<div style={{ float: 'right' }}>
							<Dropdown overlay={menu}>
								<Button type="primary" style={{ marginRight: 10 }}>
									Thao tác <Icon type="down" />
								</Button>
							</Dropdown>
						</div>
					</div>
				}>
				<Row>
					<Col span={8}>
						<InfoRow label={'Mã nhà cung cấp'} value={supplier.code} />
					</Col>
					<Col span={8}>
						<InfoRow label={'Website'} value={supplier.website} />
					</Col>
					<Col span={8}>
						<InfoRow label={'Trạng thái'} value={supplier.isTransaction ?
							<Tag style={{ width: '110px', textAlign: 'center' }} color="#87d068">Đang giao dịch</Tag> :
							<Tag style={{ width: '110px', textAlign: 'center' }} color="#f50">Ngừng giao dịch</Tag>} />
					</Col>
					<Col span={8}>
						<InfoRow label={'Số điện thoại'} value={supplier.phoneNumber} />
					</Col>
					<Col span={8}>
						<InfoRow label={'Thời gian tạo'} value={dateToString(supplier.createdDate)} />
					</Col>
					<Col span={8}>
						<InfoRow label={'Nợ hiện tại'} value={currencyVND(supplier.totalDebt)} />
					</Col>
					<Col span={8}>
						<InfoRow label={'Email'} value={supplier.email} />
					</Col>
					<Col span={8}>
						<InfoRow label={'Thời gian cập nhật'} value={dateToString(supplier.updatedDate)} />
					</Col>
				</Row>
			</Card>
			<Card className={'mt-20'}>
				<Tabs defaultActiveKey={currentTab} onChange={t => setCurrentTab(t)}>
					<TabPane tab="Lịch sử nhập hàng" key="1">
						<OrderHistory />
					</TabPane>
					<TabPane tab="Công nợ" key="2">
						<DebtHistory reload={reloadDebtList} />
					</TabPane>
				</Tabs>
			</Card>
			<CreateTicket visible={showModalCreateTicket}
										setVisible={setShowModalCreateTicket}
										supplierId={supplier.id}
										isIncome={isIncome}
										callback={() => setReloadDebtList(reloadDebtList + 1)}
			/>
		</Fragment>);
};

